import $ from 'jquery';
import { getAdvUnreadCount } from 'messaging/api';
import { MessageTypes } from 'messaging/constants';
import { addListener } from 'services/sse';

const getUserItem = () => $('#navbar').find('.item.user');

export default function bind() {
  const $item = getUserItem();
  const role = $item.attr('data-role');

  if (role && role.length) {
    handleNavbarForRole($item, role);
  }
}

function handleNavbarForRole($item, role) {
  switch (role) {
    case 'admin':
      return handleAdminNavbar($item);
    default:
      return;
  }
}

// Messaging
// TODO: Externalize it ?

function handleAdminNavbar($item) {
  const displayMessageCount = value => {
    if (value > 0) {
      drawMessagingCounter($item, value);
    }
  };

  const incrementCounter = () =>
    drawMessagingCounter($item, getMessagingCounterValue($item) + 1);

  // Listening for sse messages
  addListener(msg => {
    if (msg._type && msg._type === MessageTypes.MESSAGE_CREATED) {
      incrementCounter();
    }
  });

  // Loading unread message count and displaying it
  getAdvUnreadCount().then(displayMessageCount);
}

export function decrementMessagingCounter(value) {
  const $item = getUserItem();
  drawMessagingCounter($item, getMessagingCounterValue($item) - value);
}

function getMessagingCounterValue($item) {
  const content = $item.find('.label.counter').html();
  return content && content.length ? Number(content) : 0;
}

function drawMessagingCounter($item, value) {
  $item.find('.label.counter').remove();

  if (value > 0) {
    $item.append(`<div class="ui small red label counter">${value}</div>`);
  }
}



// WEBPACK FOOTER //
// ./src/plugins/navbar.js